import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Quote from "components/Typography/Quote.jsx";
// core components

import SectionDestacadas from "KComponents/SectionDestacadas.jsx";
import SectionRecents from "KComponents/SectionRecents.jsx";

import sectionTextStyle from "assets/jss/material-kit-pro-react/views/blogPostSections/sectionTextStyle.jsx";

function SectionText({ ...props }) {
  const { classes } = props;
  const { featured } = props;
  const { recents } = props;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>
            Our dedicated rural research team offers a range of original and bespoke consultancy solutions to clients across all rural disciplines, from property management and asset performance to rural policy evaluation and agribusiness strategy.
          </h3>
          <p>


            Working predominantly nationally but also globally, our core team works at the forefront of all rural areas, providing the latest market trends and analysis of the energy, estates, food and farming, forestry, leisure, minerals and waste management related sectors. Many of our experienced analysts have practical farming backgrounds too, giving invaluable expertise while also drawing on their connections with professionals and research teams across all sectors within the global Kinos & Torus network and beyond.
            <br />  <br />
            Each client is treated individually, with analysts tailoring their work to suit clients’ objectives. Our fields of expertise can cover all bases depending on what is required, including risk evaluation, strategic analysis, benchmarking, data management, forecasting, feasibility studies, surveys, rural rents, investment and asset performance. Our clients include farm and rural estate managers, public and private, institutions and investors, banks and property fund managers, government agencies, corporations and the supply chain (input and output) from farmers to retailers.
          </p>
          <Quote
            textClassName={classes.quoteText}
            text="“Excellence is our Goal, customers satisfaction our proud!”"
            author="Joaquín Morales, CEO."
          />
        </GridItem>
        <GridItem xs={12} sm={10} md={10} className={classes.section}>
          <SectionRecents recents={recents} url="rural_land" />
          <SectionDestacadas featured={featured} url="rural_land" />
        </GridItem>

        <GridItem xs={12} sm={8} md={8} id="search" >
        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(sectionTextStyle)(SectionText);
